import React from 'react';
import { DailyDto } from 'src/api/FiretrolApiClient';
import { Header } from 'src/design/organisms/Header';
import { useDailys } from 'src/api/queries/dailys/useDailys';
import { useJobs } from 'src/hooks/useJobs';
import { DailyTable } from './DailyTable';

const EMPTY_DAILYS: DailyDto[] = [];

export const Dailys: React.FC = () => {
  const { selectedJob } = useJobs();
  const { data: dailys = EMPTY_DAILYS, isLoading } = useDailys(
    { jobId: selectedJob?.id },
    { enabled: !!selectedJob },
  );

  if (!selectedJob) return null;
  return (
    <>
      <Header
        title="Dailys"
        breadcrumbProps={{
          items: [
            { text: 'Jobs', href: '/jobs' },
            {
              text: `${selectedJob?.name} - ${selectedJob?.jobNumber}`,
              href: `/jobs/${selectedJob?.id}/summary`,
            },
            { text: 'Dailys' },
          ],
        }}
        helpText="View and manage daily reports for this job"
      />

      <DailyTable dailys={dailys} loading={isLoading} />
    </>
  );
};
